/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // --- Furavelle: upsell urgency countdown (custom element) ---
  // Defined globally so it works even when the cart drawer is re-rendered via AJAX.
  if (window.customElements && !customElements.get('fv-upsell-timer')) {
    var KEY = 'fvUpsellDeadline';
    var DURATION = 15 * 60 * 1000; // 15 minutes

    var getDeadline = function () {
      var d = sessionStorage.getItem(KEY);
      if (!d) { d = String(Date.now() + DURATION); sessionStorage.setItem(KEY, d); }
      return parseInt(d, 10);
    };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    customElements.define('fv-upsell-timer', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this._render = function () {
          var rem = getDeadline() - Date.now();
          if (rem < 0) { rem = 0; }
          var m = Math.floor(rem / 60000);
          var s = Math.floor((rem % 60000) / 1000);
          self.textContent = pad(m) + ':' + pad(s);
          if (rem === 0) {
            var wrap = self.closest('[data-upsell-urgency]');
            if (wrap) { wrap.style.opacity = '0.6'; }
            clearInterval(self._t);
          }
        };
        this._render();
        this._t = setInterval(this._render, 1000);
      }
      disconnectedCallback() { clearInterval(this._t); }
    });
  }

  // --- Furavelle: "Your design ✓ Saved" line item property (hiện ở checkout) ---
  // Checkout chỉ hiện property KHÔNG bắt đầu bằng "_". Teeinblue chỉ ghi _customization_image (ẩn),
  // nên ta bổ sung 1 property hiển thị cho mỗi món có design. Không sửa/xoá property của Teeinblue.
  (function () {
    var PROP_KEY = 'Your design';
    var PROP_VAL = '✓ Saved — prints exactly as previewed in your cart';
    var busy = false, timer = null;

    function syncCart() {
      if (busy) return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var todo = [];
          (cart.items || []).forEach(function (it, idx) {
            var p = it.properties || {};
            if (p._customization_image && !p[PROP_KEY]) todo.push({ line: idx + 1, props: p });
          });
          if (!todo.length) return;
          busy = true;
          var chain = Promise.resolve();
          todo.forEach(function (t) {
            chain = chain.then(function () {
              var props = {};
              Object.keys(t.props).forEach(function (k) { props[k] = t.props[k]; });
              props[PROP_KEY] = PROP_VAL;
              return fetch('/cart/change.js', {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ line: t.line, properties: props })
              });
            });
          });
          chain.then(function () { busy = false; }, function () { busy = false; });
        })
        .catch(function () {});
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(syncCart, 900); }

    // Chạy khi trang load, và sau mỗi lần giỏ thay đổi (Teeinblue add-to-cart dùng fetch/XHR)
    schedule();
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (!busy && /\/cart\/(add|change|update)/.test(url)) p.then(schedule, function () {});
      return p;
    };
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (!busy && /\/cart\/(add|change|update)/.test(String(url))) this.addEventListener('loadend', schedule);
      return _open.apply(this, arguments);
    };
    document.addEventListener('theme:cart:change', schedule);
  })();


  // --- Furavelle: ô nhắc trên nút Checkout (cart page + cart drawer) ---
  // Chỉ hiện khi giỏ có món có ảnh design Teeinblue. Tự cập nhật khi drawer re-render.
  (function () {
    var ID = 'fv-checkout-note';
    function hasCustom(root) {
      return !!root.querySelector('img[src*="cdn.teeinblue.com/customizations"], img[srcset*="cdn.teeinblue.com/customizations"]');
    }
    function inject() {
      document.querySelectorAll('[data-cart-checkout-buttons]').forEach(function (cb) {
        var scope = cb.closest('.cart-drawer, cart-element, cart-drawer, .cart__content') || cb.closest('form') || document;
        var prev = cb.previousElementSibling;
        var existing = (prev && prev.classList.contains(ID)) ? prev : null;
        if (!hasCustom(scope)) { if (existing) existing.remove(); return; }
        if (existing) return;
        var n = document.createElement('div'); n.className = ID;
        n.innerHTML = '<span class="' + ID + '__icon">✓</span><span><strong>Your design is saved.</strong> The next page shows our catalogue photo instead of your pet — that\'s normal. What you see above is exactly what we print.</span>';
        cb.parentNode.insertBefore(n, cb);
      });
    }
    if (!document.getElementById(ID + '-css')) {
      var s = document.createElement('style'); s.id = ID + '-css';
      s.textContent = '.' + ID + '{display:flex;gap:8px;align-items:flex-start;margin:0 0 10px;padding:10px 12px;border-radius:8px;background:#E6F3EC;color:#1F5A3F;font-size:13px;line-height:1.45}'
        + '.' + ID + '__icon{flex:0 0 auto;width:18px;height:18px;border-radius:50%;background:#2E8B5F;color:#fff;font-size:11px;font-weight:700;display:inline-flex;align-items:center;justify-content:center;margin-top:1px}';
      document.head.appendChild(s);
    }
    var t = null;
    function schedule() { clearTimeout(t); t = setTimeout(inject, 150); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();